import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "datatables.net-buttons-bs5";

export default class extends Controller {
  static targets = ["verifiedFilter", "dateFromFilter", "dateToFilter"];

  connect() {
    const tableElement = $(this.element).find("#customers-table");

    this.dataTable = tableElement.DataTable({
      pageLength: 10,
      lengthMenu: [5, 10, 25, 50],
      order: [[1, "asc"]],
      dom:
        "<'row mb-3'<'col-sm-2'l><'col-sm-6 text-end'B>>" +
        "<'row mb-3'<'col-sm-6'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        { extend: "excelHtml5", className: "btn btn-outline-success btn-sm me-2 rounded-pill", text: "Excel" },
        { extend: "csvHtml5", className: "btn btn-outline-primary btn-sm me-2 rounded-pill", text: "CSV" },
        { extend: "print", className: "btn btn-outline-secondary btn-sm rounded-pill", text: "Print" }
      ],
      language: { searchPlaceholder: "Type to Search...", search: "" }
    });

    // Custom filtering function
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      if (settings.nTable !== tableElement[0]) return true;

      const verifiedFilter = this.verifiedFilterTarget.value;
      const rowVerified = data[3].includes("Yes"); // YES/NO badge column

      const dateFrom = this.dateFromFilterTarget.value;
      const dateTo = this.dateToFilterTarget.value;
      const createdAt = data[5]; // Created At column

      // Verification filtering
      if (verifiedFilter === "verified" && !rowVerified) return false;
      if (verifiedFilter === "unverified" && rowVerified) return false;

      // Date filtering
      if (dateFrom && createdAt < dateFrom) return false;
      if (dateTo && createdAt > dateTo) return false;

      return true;
    });

    // Refilter on change
    this.verifiedFilterTarget.addEventListener("change", () => this.refresh());
    this.dateFromFilterTarget.addEventListener("change", () => this.refresh());
    this.dateToFilterTarget.addEventListener("change", () => this.refresh());
  }

  refresh() {
    this.dataTable.draw();
  }

  clearFilters() {
  // Reset our filter inputs
  this.verifiedFilterTarget.value = "";
  this.dateFromFilterTarget.value = "";
  this.dateToFilterTarget.value = "";

  // Clear DataTables global search box
  this.dataTable.search("").draw();

  // Redraw table to remove custom filtering
  this.dataTable.draw();
}

}
